var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.link}},[_c('pill-with-label',{scopedSlots:_vm._u([{key:"icon",fn:function(){return [_vm._t("icon")]},proxy:true},{key:"content",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }